// extracted by mini-css-extract-plugin
module.exports = {"card":"PasswordChangeSuccess_card__XukDh"};